module.exports = __webpack_public_path__ + "img/img-13.82f7d87a.png";